/** Tooltips support mouse hover, keyboard focus, and tapping on touch screens. */
export function bindInfoTooltips(rootEl: HTMLElement): () => void {
	const controller = new AbortController()
	const { signal } = controller
	for (const wrapper of rootEl.querySelectorAll<HTMLElement>(
		'[data-info-tooltip]',
	)) {
		const button = wrapper.querySelector('button')
		const text = wrapper.querySelector<HTMLElement>('[role="tooltip"]')
		if (!button || !text) continue
		const show = () => {
			text.hidden = false
		}
		const hide = () => {
			text.hidden = true
		}
		wrapper.addEventListener(
			'pointerenter',
			(event) => {
				if (event.pointerType === 'mouse') show()
			},
			{ signal },
		)
		wrapper.addEventListener(
			'pointerleave',
			() => {
				if (document.activeElement !== button) hide()
			},
			{ signal },
		)
		button.addEventListener('focus', show, { signal })
		button.addEventListener('blur', hide, { signal })
		button.addEventListener('click', show, { signal })
		document.addEventListener(
			'pointerdown',
			(event) => {
				if (
					event.target instanceof Node &&
					!wrapper.contains(event.target)
				)
					hide()
			},
			{ signal },
		)
		document.addEventListener(
			'keydown',
			(event) => {
				if (event.key === 'Escape') hide()
			},
			{ signal },
		)
	}
	return () => controller.abort()
}
